<template>
  <md-toolbar>
    <h3 class="md-title" style="flex: 1">{{totalCount}} {{resultType}}</h3>
    <md-field class="search" md-inline>
      <label>Search</label>
      <md-input v-model="searchInput" @keyup.enter="startSearch(searchInput)"></md-input>
    </md-field>
    <md-button class="md-icon-button" @click="startSearch(searchInput)">
      <md-icon>search</md-icon>
    </md-button>
    <md-button v-if="searchInput !== null && searchInput !== ''" class="md-icon-button" @click="clearInput()">
      <md-icon>clear</md-icon>
    </md-button>
    <div class="md-toolbar-section-end">
      <md-field class="orderby">
        <label for="sortFields">Order By:</label>
        <md-select v-model="selectedSortField" name="sortFields" id="sortFields">
          <md-option v-for="(sortField, index) in sortFields" :key="index" v-bind:value=sortField>{{sortField}}</md-option>
        </md-select>
      </md-field>
      <md-button @click="changeSort()" v-text="sortOrderText()">
      </md-button>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  name: 'SearchToolbar',
  data: () => ({
    selectedSortField: null,
    searchInput: null,
    sortOrder: 'asc'
  }),
  props: ['totalCount', 'from', 'to', 'sortFields', 'resultType'],
  methods: {
    startSearch (searchTerm) {
      this.$emit('search', {'from': 0, 'to': 60, 'SortOrder': this.sortOrder, 'textFilter': searchTerm, 'SortField': this.selectedSortField})
    },
    clearInput () {
      this.searchInput = null
      this.$emit('clearsearch', {'from': 0, 'to': 60, 'SortOrder': this.sortOrder, 'textFilter': '', 'SortField': this.selectedSortField})
    },
    changeSort () {
      this.sortOrder === 'asc' ? this.sortOrder = 'desc' : this.sortOrder = 'asc'
      this.$emit('changeSort', this.sortOrder)
    },
    sortOrderText () {
      return this.sortOrder === 'asc' ? 'A-Z' : 'Z-A'
    }
  },
  mounted: function () {
    this.selectedSortField = this.sortFields ? this.sortFields[0] : null
  }
}
</script>

<style lang="scss" scoped>
  .search {
    max-width: 500px;
  }
  .orderby {
    max-width: 200px;
  }
</style>
